import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Masonry from 'react-masonry-component'

const masonryOptions = {
  itemSelector: '.press-item',
  columnWidth: '.press-item',
  gutter: 20,
  transitionDuration: 0
}

const imagesLoadedOptions = {}

const PressGallery = props => {
  const { items } = props

  return (
    <div className={`press ${props.getColumnClass(props.width)}`}>
      <Masonry
        className="press-masonry"
        elementType="ul"
        options={masonryOptions}
        disableImagesLoaded={false}
        updateOnEachImageLoad={false}
        imagesLoadedOptions={imagesLoadedOptions}
      >
        {items.length > 0 ? (
          items.map(item => (
            <li className="press-item" key={item.ID}>
              <article>
                <a
                  className="press-item-link press-item-tag mod-outlet"
                  href={item.fields.article_link}
                  target="_blank"
                  data-id="publication"
                >
                  {item.fields.outlet}
                </a>
                <a className="press-item-link" href={item.fields.article_link} target="_blank">
                  {item.featured_image && (
                    <img
                      className="press-item-featured-image"
                      src={item.featured_image.medium_large[0]}
                      alt=""
                    />
                  )}
                </a>
                <header>
                  <div className="press-item-meta type-body mod-ui">
                    <span data-id="date" className="press-item-tag mod-date">
                      {item.post_date}
                    </span>
                    {item.fields.article_type && (
                      <span
                        data-id="type"
                        className="press-item-tag mod-type"
                        onClick={e => props.toggleFilter(e, item.fields.article_type.toLowerCase())}
                      >
                        {item.fields.article_type}
                      </span>
                    )}
                  </div>
                  <a className="press-item-link" href={item.fields.article_link} target="_blank">
                    <h1 className="press-item-tag mod-title type-body mod-ui">{item.post_title}</h1>
                  </a>
                </header>
              </article>
            </li>
          ))
        ) : (
          <p>No press items yet.</p>
        )}
      </Masonry>
    </div>
  )
}

PressGallery.propTypes = {
  items: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func,
  toggleSort: PropTypes.func
}

export default PressGallery
